// extracted by mini-css-extract-plugin
export default {"lowPlannerSupply":"lowPlannerSupply__M2U3Z","hed":"hed__ZTVmZ"};